<div class="row">
    <div class="col-md-3 mt-3" *ngFor="let repository of repositories">
        <div class="card shadow" style="max-width: 500px;">
            <div class="row no-gutters">
                <div class="col-md-12">
                    <div class="card-body">
                        <h5 class="card-title"><b>{{repository.name}}</b></h5>
                        <p class="card-text"><small class="text-muted">{{repository.description}}</small></p>
                        <p class="card-text">
                            <small class="text-muted">Creado: {{repository.created_at | date: 'dd/MM/yyyy'}}</small>&nbsp;
                            <span *ngIf="repository.language" style="background-color: #007bff" class="repo-language-color"></span>
                            <small class="text-muted"> {{repository.language}}</small>
                            <span class="ml-1" *ngIf="repository.stargazers_count">
                                        <svg aria-label="star" class="octicon octicon-star" viewBox="0 0 14 16" version="1.1" width="14" height="16" role="img">
                                          <path fill-rule="evenodd" d="M14 6l-4.9-.64L7 1 4.9 5.36 0 6l3.6 3.26L2.67 14 7 11.67 11.33 14l-.93-4.74L14 6z"></path>
                                        </svg>
                                        {{repository.stargazers_count}}
                                    </span>
                        </p>
                        <a href="{{repository.html_url}}">
                            <i class="fa-brands fa-github"></i>
                            Repositorio</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>